import { toLines } from '../../../../common/utils'

const cuisineTypeSimpleDetailsFormInitialValues = ({
  description,
  synonyms,
  position,
  isErrorProne,
  isExcludedFromSearch,
  isExcludedFromBrowsing,
}) => ({
  description,
  position,
  isErrorProne,
  isExcludedFromSearch,
  synonyms: toLines(synonyms),
  isExcludedFromBrowsing,
})

export default cuisineTypeSimpleDetailsFormInitialValues
